import { TextInput as MantineTextInput, TextInputProps as MantineTextInputProps } from '@mantine/core';

import styles from '../styles/Input.module.css';
import { forwardRef } from 'react';

export type TextInputProps = MantineTextInputProps;

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(props, ref) {
    return (
        <MantineTextInput
            ref={ref}
            classNames={{
                input: styles.input,
                label: styles.label,
                description: styles.description,
                required: styles.required,
            }}
            {...props}
        />
    );
});
